import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=e5c32a4a&"
var script = {}
import style0 from "./Error500.vue?vue&type=style&index=0&id=e5c32a4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports